import { render } from "./RegisterPincode.vue?vue&type=template&id=b7144426&scoped=true"
import script from "./RegisterPincode.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPincode.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPincode.vue?vue&type=style&index=0&id=b7144426&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7144426"],['__file',"src/views/register/RegisterPincode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7144426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7144426', __exports__)) {
    api.reload('b7144426', __exports__)
  }
  
  module.hot.accept("./RegisterPincode.vue?vue&type=template&id=b7144426&scoped=true", () => {
    api.rerender('b7144426', render)
  })

}


export default __exports__